import { Subscribable } from 'knockout';

export interface ShellRoutesGroupConfig {
    ready?: Subscribable<boolean>
    enable?: Subscribable<boolean>
    exclusive?: boolean

    routes: Array<DurandalRouteConfiguration>
}

class ShellRoutesGroup {
    ready: Subscribable<boolean>
    enable: Subscribable<boolean>
    exclusive: boolean

    routes: Array<DurandalRouteConfiguration>

    constructor(config: ShellRoutesGroupConfig) {
        this.ready = config.ready ?? ko.pureComputed(() => true);
        this.enable = config.enable ?? ko.pureComputed(() => true);
        this.exclusive = config.exclusive ?? false;

        this.routes = config.routes;
    }
}

export default class ShellRoutesComposition {
    static create(configs: Array<ShellRoutesGroupConfig>) {
        const groups = ko.pureComputed(() => configs.map(config => new ShellRoutesGroup(config)));

        return groups.filter(g => g.enable()).mapSingle(groups => {
            if (!groups.every(g => g.ready()))
                return [];

            const exclusiveGroup = groups.find(g => g.exclusive);

            if (exclusiveGroup != undefined)
                return exclusiveGroup.routes;

            return groups.flatMap(g => g.routes);
        });
    }
}